import { Trans } from 'react-i18next';
import FeatureCard from '../components/FeatureCard';
import LocationComponent from '../components/LocationComponent';

const AstroLocationCluster = ({ project, handleChange, className }) => (
    <FeatureCard title={<Trans i18nKey="Location" />} className={className} style={{ width: '50%' }}>
        <LocationComponent
            project={project}
            onUpdateProject={handleChange}
        />
    </FeatureCard>
);

export default AstroLocationCluster;
